import { createServerStateStore } from "./serverState";

export interface AuditLogRecord {
  id: string;
  createdAt: string;
  userId?: number;
  userName: string;
  userRole?: string;
  page: string;
  table: string;
  action: string;
  recordKey: string;
  detail: string;
  changes?: Record<string, { before: unknown; after: unknown }>;
}

function normalizeLog(value: unknown): AuditLogRecord {
  const item = (value ?? {}) as Partial<AuditLogRecord>;
  return {
    id: String(item.id || crypto.randomUUID()),
    createdAt: String(item.createdAt || new Date().toISOString()),
    userId: typeof item.userId === "number" ? item.userId : undefined,
    userName: String(item.userName || "Sistem"),
    userRole: item.userRole ? String(item.userRole) : undefined,
    page: String(item.page || "Genel"),
    table: String(item.table || "—"),
    action: String(item.action || "Güncelleme"),
    recordKey: String(item.recordKey || "—"),
    detail: String(item.detail || "İşlem kaydı"),
    changes:
      item.changes && typeof item.changes === "object"
        ? item.changes
        : undefined,
  };
}

function normalizeLogs(value: unknown): AuditLogRecord[] {
  if (!Array.isArray(value)) return [];
  return value.map(normalizeLog).slice(0, 5000);
}

const store = createServerStateStore<AuditLogRecord[]>(
  "audit_logs",
  [],
  normalizeLogs,
  { pollIntervalMs: 10000 }
);

export function getAuditLogs() {
  return store.getState();
}

export async function rehydrateAuditLogs() {
  return store.rehydrate();
}

export function subscribeAuditLogs(listener: () => void) {
  return store.subscribe(listener);
}
